export const BUSINESS_BILL_PAY_CONTAINER_TAG_NAME = 'business-bill-pay-container';
